<template>
  <section
    id="cards"
    class="bg-mobile lg:bg lg:p-10 xl:px-140px 3xl:px-200px 4xl:px-300px pt-10"
  >
    <div class="px-8 md:px-4 xl:px-0 text-qwray md:flex md:flex-col md:pt-5">
      <div
        class="md:flex HeaderContainer sm:w-3/4 md:w-full md:justify-between md:flex-row md:justify-center sm:justify-evenly"
      >
        <div class="md:w-3/5 lg:w-3/6 xl:w-3/6">
          <div
            class="font-thin text-16px leading-60px md:text-20px tracking-2.4px px-1 "
          >
            {{ $t('our_solution.small_header') }}
          </div>
          <div
            class="font-Foco text-30px md:text-40px lg:text-50px xl:text-70px px-1 xl:leading-80px"
          >
            <div class="font-bold">
              {{ $t('our_solution.big_header') }}
            </div>
          </div>
        </div>
        <div
          class="mt-3 Text py-4 border-l-4 border-solid border-qwray pl-4 font-qwraylight md:w-1/3 text-14px md:text-14px xl:text-20px"
        >
          <div>
            {{ $t('our_solution.txt1') }}
          </div>
          <div class="mt-4">
            {{ $t('our_solution.txt2') }}
          </div>
          <div class="font-bold mt-4">{{ $t('our_solution.txt3') }}</div>
        </div>
      </div>
      <div class="mt-4 py-4 sm:flex md:mt-20 sm:justify-between gap-4">
        <feature-card
          v-for="(card, index) in cards"
          v-bind:card="card"
          v-bind:index="index"
          v-bind:key="index"
          v-bind:header="card.header"
          v-bind:text="card.text"
          v-bind:first="index == 0"
          v-bind:icon="card.icon"
          :style="{ width: `${100 / cards.length}%` }"
        ></feature-card>
      </div>
    </div>
  </section>
</template>
<script>
import FeatureCard from './FeatureCard.vue';
import { cardScreenCards } from '../../../shared/entitySpecificData';

export default {
  name: 'CardsScreen',
  components: {
    FeatureCard,
  },
  data() {
    return {
      cards: cardScreenCards(),
    };
  },
};
</script>

<style scoped>
@responsive {
  .bg {
    background-image: url('~@/assets/bg-yellow-desktop.svg');
    background-repeat: no-repeat;
    background-size: 50%;
  }
}
@responsive {
  .bg-mobile {
    background-image: url('~@/assets/bg-yellow-mobile.svg');
    background-repeat: no-repeat;
  }
}

.HeaderContainer {
  padding: 0;
}

.Text {
  height: max-content;
  align-self: center;
}
@media (min-width: 768px) {
  .HeaderContainer {
    padding: 0 2em;
  }
}
@media (min-width: 1024px) {
  .Max {
    align-self: center;
  }
  .HeaderContainer {
    padding: 0;
  }
}
</style>
